
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/navigation-map",
      function () {
        return require("private-next-pages/navigation-map/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/navigation-map"])
      });
    }
  